// DEPENDENCIES
import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import * as _ from 'lodash';
//COMPONENTS
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import MUIDataTable from "mui-datatables";
import Flatpickr from "react-flatpickr";
import BlockUi from 'react-block-ui';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
//CUSTOM COMPONENTS
import DateFilterComponent from '../../components/DateFilterComponent';
//SERVICES AND HELPERS
import * as helper from '../../../helpers/helper';
import * as clientService from '../../../services/management/clientService';
import * as jobService from '../../../services/service/jobService';
import * as userService from '../../../services/management/userService';
import * as reportService from '../../../services/report/reportService';

const TimeLogReportPage = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [clientOptions, setClientOptions] = useState(null);
    const [jobOptions, setJobOptions] = useState(null);
    const [userOptions, setUserOptions] = useState(null);
    const [reportType, setReportType] = useState(null);
    const [groupedTimeList, setGropuedTimeList] = useState([]);
    const [isGroupedView, setIsGroupedView] = useState(true);
    const [selectedOptions, setSelectedOptions] = useState({
        client: null,
        job: null,
        user: null,
        startDate: null,
        endDate: null
    })

    useEffect(() => {
        fetchClients();
        fetchUsers();
    }, [fetchClients, fetchUsers]);

    useEffect(() => {
        clearSelectedOptions();
        if (reportType)
            if (reportType.value == "Job") {
                fetchJobs(0);
            }
    }, [reportType, fetchJobs, clearSelectedOptions])

    useEffect(() => {
        if (selectedOptions.client) {
            fetchJobs(selectedOptions.client.value);
        }
    }, [selectedOptions.client, fetchJobs])

    const fetchClients = useCallback(() => {
        clientService.getClients().then(res => {
            setClientOptions(res.map(x => {
                return helper.setToOptionModel(x.name, x.id);
            }))
        })
    }, [])

    const fetchJobs = useCallback((clientId) => {
        setLoading(true);
        jobService.getJobsByClient(clientId).then(res => {
            setJobOptions(res.map(x => {
                return helper.setToOptionModel(x.proposal.projectNumber + " - " + x.proposal.projectName, x.id);
            }))
        }).catch(ex => {

        }).finally(() => setLoading(false));
    }, [])

    const fetchUsers = useCallback(() => {
        userService.getAllUsers(false).then(res => {
            setUserOptions(res.map(x => {
                return helper.setToOptionModel(x.fullName, x.id);
            }))
        })
    }, [])

    const resetSearch = () => {
        setReportType(null);
        clearSelectedOptions();
        setData([]);
        setGropuedTimeList([]);
    }

    const clearSelectedOptions = useCallback(() => {
        setSelectedOptions({
            client: null,
            job: null,
            user: null,
            startDate: null,
            endDate: null
        });
    }, []);

    const generateTimeLogReport = () => {
        setLoading(true);
        let requestModel = {
            clientId: selectedOptions.client ? selectedOptions.client.value : null,
            jobIds: selectedOptions.job ? (Array.isArray(selectedOptions.job) ? selectedOptions.job.map(x => x.value) : [selectedOptions.job.value]) : null,
            userIds: selectedOptions.user ? [selectedOptions.user.value] : null,
            startDate: selectedOptions.startDate,
            endDate: selectedOptions.endDate,
            allActiveJobs: reportType.value === "Active Jobs"
        }

        reportService.getTimeLogReport(requestModel).then(res => {
            setData(res);
            if (res) {
                setGropuedTimeList(
                    _.chain(res)
                        // Group the elements of Array based on `date` property
                        .groupBy('date')
                        // `key` is group's name (color), `value` is the array of objects
                        .map((value, key) => ({
                            date: key,
                            timeSheet: value,
                            totalMinutes: value.reduce((a, b) => a + parseInt(moment.duration(moment(b.clockOut).diff(b.clockIn)).asMinutes()), 0),
                            totalAmount: value.reduce((a, b) => a + b.cost, 0).toFixed(2)
                        }))
                        .value()
                );
            }
        }).catch(ex => {

        }).finally(() => setLoading(false))
    }

    const columns = [
        {
            name: "clockIn",
            label: "Date",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customFilterListRender: v => helper.dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return helper.dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Clock In"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                },
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(data[dataIndex].clockIn).format("MM/DD/YYYY")}</p>
                    );
                }
            }
        },
        {
            name: "client",
            label: "Client",
            options: {
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: "jobNumber",
            label: "Job#",
            options: {
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: "fullName",
            label: "Full Name",
            options: {
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: "clockIn",
            label: "ClockIn",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customFilterListRender: v => helper.dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return helper.dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Clock In"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                },
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(data[dataIndex].clockIn).format("HH:mm")}</p>
                    );
                }
            }
        },
        {
            name: "clockOut",
            label: "Clock Out",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customFilterListRender: v => helper.dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return helper.dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Clock Out"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                },
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(data[dataIndex].clockOut).format("HH:mm")}</p>
                    );
                }
            }
        },
        {
            name: "hoursWorked",
            label: "Hours Worked",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    if (data[dataIndex].clockOut) {
                        var duration = moment.duration(moment(data[dataIndex].clockOut).diff(data[dataIndex].clockIn));

                        // duration in hours
                        var hours = parseInt(duration.asHours());

                        // duration in minutes
                        var minutes = parseInt(duration.asMinutes()) % 60;

                        return (
                            <p>{hours + ' hours and ' + minutes + ' minutes'}</p>
                        );
                    }

                    return <p>-</p>
                }
            }
        },
        {
            name: "cost",
            label: "Cost",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>${(data[dataIndex].cost).toFixed(2)}</p>
                    );
                }
            }
        },
    ];

    return (
        <div className="card card-custom" >
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        Time Log Report
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        View Time Log Report
                    </span>
                </div>
                <div className="card-toolbar">
                    <Link
                        to="/"
                        className="btn btn-secondary"
                    >
                        Cancel
                    </Link>
                </div>
            </div>
            <BlockUi tag="div" blocking={loading}>
                <div className="row">
                    <div className="card-body">
                        <div className="form">
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Report Type
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Select
                                        isClearable
                                        value={reportType}
                                        options={["Active Jobs", "Job", "User", "Client"].map(x => {
                                            return helper.setToOptionModel(x, x)
                                        })}
                                        onChange={(value) => {
                                            setReportType(value)
                                        }}
                                        name="trainingTypeId"
                                        placeholder="Select Time Log Report Type"
                                    />
                                </div>
                            </div>
                            {
                                reportType &&
                                <>
                                    {
                                        reportType.value === "Client" &&
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Client
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <Select
                                                    value={selectedOptions.client}
                                                    options={clientOptions}
                                                    onChange={(value) => {
                                                        setSelectedOptions({ ...selectedOptions, client: value })
                                                    }}
                                                    placeholder="Select Client"
                                                />
                                            </div>
                                        </div>
                                    }
                                    {
                                        (reportType.value === "Client" || reportType.value === "Job") &&
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Job
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <Select
                                                    isClearable
                                                    isMulti={reportType.value === "Client"}
                                                    value={selectedOptions.job}
                                                    options={jobOptions}
                                                    onChange={(value) => {
                                                        setSelectedOptions({ ...selectedOptions, job: value })
                                                    }}
                                                    placeholder="Select Job"
                                                />
                                            </div>
                                        </div>
                                    }
                                    {
                                        reportType.value === "User" &&
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                User
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <Select
                                                    isClearable
                                                    value={selectedOptions.user}
                                                    options={userOptions}
                                                    onChange={(value) => {
                                                        setSelectedOptions({ ...selectedOptions, user: value })
                                                    }}
                                                    placeholder="Select User"
                                                />
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Start Date
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Flatpickr
                                        placeholder="MM/DD/YYYY"
                                        options={{
                                            enableTime: false,
                                            dateFormat: "m/d/Y",
                                        }}
                                        value={moment(selectedOptions.startDate).format("MM/DD/YYYY")}
                                        onChange={date => {
                                            setSelectedOptions({ ...selectedOptions, startDate: date[0] })
                                        }}
                                        className="form-control form-control-lg form-control-solid"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    End Date
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Flatpickr
                                        placeholder="MM/DD/YYYY"
                                        options={{
                                            enableTime: false,
                                            dateFormat: "m/d/Y",
                                            minDate: selectedOptions.startDate
                                        }}
                                        value={moment(selectedOptions.endDate).format("MM/DD/YYYY")}
                                        onChange={date => {
                                            setSelectedOptions({ ...selectedOptions, endDate: date[0] })
                                        }}
                                        className="form-control form-control-lg form-control-solid"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row col-lg-12 col-xl-12 search-clear-btn-group mt-lg-5 flex-row mb-lg-10" style={{ justifyContent: 'flex-end' }}>
                            <button
                                disabled={(selectedOptions.client == null && selectedOptions.job === null && selectedOptions.user === null && !reportType)}
                                className="btn btn-primary font-weight-bolder font-size-sm mr-3"
                                onClick={generateTimeLogReport}
                            >
                                Generate Report
                            </button>{' '}
                            <button className="btn btn-secondary font-weight-bolder font-size-sm mr-3" onClick={resetSearch}>
                                Clear
                            </button>
                        </div>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isGroupedView}
                                    onChange={() => {
                                        setIsGroupedView(!isGroupedView)
                                    }}
                                    value="checkedB"
                                    color="primary"
                                />
                            }
                            label="Grouped View"
                        />
                        {
                            isGroupedView ?
                                <>
                                    {
                                        groupedTimeList.map((x, index) => (
                                            <ExpansionPanel key={index} name={index}>
                                                <ExpansionPanelSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>{x.date} - ({x.timeSheet.length} entries)</Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Date</TableCell>
                                                                <TableCell align="right">Client</TableCell>
                                                                <TableCell align="right">Job#</TableCell>
                                                                <TableCell align="right">Full Name</TableCell>
                                                                <TableCell align="right">ClockIn</TableCell>
                                                                <TableCell align="right">Clock Out</TableCell>
                                                                <TableCell align="right">Total Hours Worked</TableCell>
                                                                <TableCell align="right">Cost</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {x.timeSheet.map((row) => (
                                                                <TableRow key={row.name}>
                                                                    <TableCell component="th" scope="row">
                                                                        {row.date}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {row.client}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {row.jobNumber}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {row.fullName}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {moment(row.clockIn).format("HH:mm")}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {moment(row.clockOut).format("HH:mm")}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {
                                                                            (row.clockOut) ?
                                                                                parseInt(moment.duration(moment(row.clockOut).diff(row.clockIn)).asHours())
                                                                                + ' hour and ' +
                                                                                parseInt(moment.duration(moment(row.clockOut).diff(row.clockIn)).asMinutes() % 60)
                                                                                + ' minutes'
                                                                                : "-"
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        $ {(row.cost).toFixed(2)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow key={index}>
                                                                <TableCell align="right">
                                                                    <strong>Total</strong>
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <strong>
                                                                        {parseInt(x.totalMinutes / 60)} hours and {x.totalMinutes % 60} minutes
                                                                    </strong>
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <strong>$ {x.totalAmount}</strong>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        ))
                                    }
                                    {
                                        groupedTimeList.length > 0 &&
                                        <Table size="small">
                                            <TableRow>
                                                <TableCell align="right">
                                                    <strong>Overall Total</strong>
                                                </TableCell>
                                                <TableCell align="right">
                                                </TableCell>
                                                <TableCell align="right">
                                                </TableCell>
                                                <TableCell align="right">
                                                </TableCell>
                                                <TableCell align="right">
                                                </TableCell>
                                                <TableCell align="right">
                                                    {groupedTimeList.reduce((a, v) => v.timeSheet.length + a, 0)} Entires
                                                </TableCell>
                                                <TableCell align="right">
                                                    <strong>
                                                    {parseInt(groupedTimeList.reduce((a, v) => a + parseInt(v.totalMinutes), 0) / 60)} hours and {groupedTimeList.reduce((a, v) => a + parseInt(v.totalMinutes), 0) % 60} minutes
                                                    </strong>
                                                </TableCell>
                                                <TableCell align="right">
                                                    $ {groupedTimeList.reduce((a, v) => a + parseFloat(v.totalAmount), 0)}
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    }
                                </>
                                :
                                <MUIDataTable
                                    data={data}
                                    columns={columns}
                                    options={{
                                        rowsPerPage: 25,
                                        rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                        selectableRows: 'none',
                                        downloadOptions: {
                                            filename: 'User_Credentials.csv',
                                            filterOptions: {
                                                useDisplayedColumnsOnly: true,
                                                useDisplayedRowsOnly: true
                                            }
                                        },
                                        textLabels: {
                                            body: {
                                                noMatch: loading ?
                                                    <Spinner animation="border" size="lg" variant="info" /> :
                                                    'Sorry, no matching records found.',
                                            },
                                        }
                                    }}
                                />
                        }
                    </div>
                </div>
            </BlockUi >
        </div >
    )
}

export default TimeLogReportPage;